@if (stepper$ | async; as modules) { @if (modules.length > 1) {
<div class="stepper-container pb-lg-5">
  <nav
    class="stepper"
    [attr.aria-label]="'APPLICATION_PROGRESS_TRACKER' | globalTranslate"
  >
    @for (module of modules; track module; let i = $index) {
    <div class="step {{ getClass(modules, i) }}">
      @if (modules.length !== 12) {
      <div
        class="headline d-none d-lg-block"
        [ngClass]="{
          active: isActiveModule(module),
          'font-translate': decreaseFont(),
          'extra-font-translate': decreaseExtraFont()
        }"
        aria-hidden="true"
      >
        <span>{{ module.title | globalTranslate }}</span>
      </div>
      } @if (modules.length === 12) {
      <div
        style="width: 100%"
        class="headline d-none d-lg-block"
        [ngClass]="{
          active: isActiveModule(module),
          'font-translate': decreaseFont(),
          'extra-font-translate': decreaseExtraFont()
        }"
        aria-hidden="true"
      >
        <span>{{ module.title | globalTranslate }}</span>
      </div>
      }
      <div class="wraptext">
        <div
          class="step-inner"
          [class.active]="isActiveModule(module)"
          (click)="onModuleNavigate(module)"
          role="button"
          [attr.aria-label]="
            (module.title | globalTranslate) +
            (getStatusLabel(module.status) | globalTranslate) +
            (isNotStarted(module.status)
              ? ('UNAVAILABLE' | globalTranslate)
              : '')
          "
          [attr.tabindex]="'0'"
          [attr.aria-current]="isActiveModule(module) ? 'step' : null"
        >
          <span aria-hidden="true">
            @if (isCompleted(module.status)) {
            <img
              aria-hidden="true"
              src="../../../assets/images/⚛️ Progress-Tracker.Icon - COMPLETE.svg"
              alt=""
            />
            } @if (isNotStarted(module.status)) {
            <img
              aria-hidden="true"
              src="../../../assets/images/⚛️ Progress-Tracker.Icon - NOT STARTED .svg"
              alt=""
            />
            } @if (isInProgress(module.status)) {
            <img
              aria-hidden="true"
              src="../../../assets/images/⚛️ Progress-Tracker.Icon - IN PROGRESS.svg"
              alt=""
            />
            }
          </span>
        </div>
      </div>
      <div class="step-content d-lg-none">
        <h6 class="active" (click)="onModuleNavigate(module)">
          {{ module.title | globalTranslate }}
        </h6>
        @if (isActiveModule(module) && module?.sections?.length > 1) {
        <ul>
          @for (section of module?.sections; track section; let sectionIndex =
          $index) {
          <li class="{{ section.status }}">
            <div
              (click)="onSectionNavigate(section)"
              [class.active]="isActiveSection(section.sectionId)"
              tabindex="0"
              role="link"
              [attr.aria-label]="
                (section.title | globalTranslate) +
                ' ' +
                (sectionIndex + 1) +
                ' ' +
                ('OF' | globalTranslate) +
                ' ' +
                module.sections.length +
                (isActiveSection(section.sectionId)
                  ? ' ' + ('CURRENT_PAGE' | globalTranslate)
                  : '')
              "
            >
              {{ section.title | globalTranslate }}
            </div>
          </li>
          }
        </ul>
        }
      </div>
    </div>
    }
  </nav>
</div>
} }